// extracted by mini-css-extract-plugin
export default {"getting-started__container":"FlowGettingStarted_getting-started__container__SrkR3"};